import { makeStyles } from '@material-ui/core';

const useAccordionPanelStyles = makeStyles({
    accordionPanel: {
        marginBottom: '30px !important',
        padding: '0px 20px'
    },
    accordionPanelBody: {
        width: '100%'
    },
});

export default useAccordionPanelStyles;